import React, { useState, useEffect, useContext } from "react";
import ConfigContext from "../../context/ConfigContext";
import { ComboBox1099 } from "./ComboBox1099";
import { Table1099 } from "./Table1099";
import axios from "axios";

export const Document1099 = ({ years, viewer }) => {
	const configData = useContext(ConfigContext);

	const [year, setYear] = useState(years[0]);
	const [data, setData] = useState(null);

	useEffect(() => {
		const url = configData.REACT_APP_VIEW_1099_URL + `/${year}`;
		fetchDocuments(url);
	}, [year]);

	const fetchReport = async (url) => {
		const result = await axios.post(url, viewer);
		return result;
	};

	const fetchDocuments = (url) => {
		if (url != null) {
			fetchReport(url).then((result) => {
				setData(result.data);
			}).catch(error => {
				console.log("error fetching 1099s: ", error.message);
			});
		}
	};

	return (
		<div>
			<div style={{ textAlign: "right" }}>
				<ComboBox1099 years={years} setYear={setYear} />
			</div>
			<div>
				{data && <Table1099 data={data} year={year} />}
			</div>
		</div>
	);
};